import _ from 'lodash'
import moment from 'moment'
// let configLabels = require('src/../config/label')

export let hrms18eColumns = () => {
  let dayInMonth = 31
  let indexParentColumns = []
  // indexParentColumns.push({
  //   key: 'codcalen',
  //   name: 'รหัสกลุ่ม',
  //   class: 'align-center',
  //   style: 'min-width: 100px;'
  // })
  indexParentColumns.push({
    key: 'desc_codcalen',
    name: '',
    labelCodapp: 'HRMS18E',
    labelIndex: '20',
    style: 'min-width: 200px;'
  })

  for (let day = 1; day <= dayInMonth; day++) {
    indexParentColumns.push({
      key: 'codshift' + _.padStart(day, 2, '0'),
      name: '',
      labelCodapp: 'CODSHIFT',
      labelIndex: _.padStart(day, 2, '0'),
      class: 'align-center',
      style: 'min-width: 60px;',
      inlineType: 'text',
      eventName: 'codshift' + _.padStart(day, 2, '0'),
      columnDisabledCondition (dataRow, key, index) {
        let columnDay = parseInt(key.replace('codshift', ''))
        let month = dataRow.month
        let year = dataRow.year
        let columnDate = moment(columnDay + '/' + month + '/' + year, 'DD/MM/YYYY')
        let currentDate = moment().startOf('day')
        return columnDate < currentDate
        // let currentDay = moment().get('date')
        // return columnDay < currentDay
      },
      columnClassCondition (dataRow, key, index) {
        let day = key.substring(8)
        let typwork = dataRow['typwork' + day]
        if (typwork === 'H') {
          return 'typework-h-cell'
        } else if (typwork === 'W') {
          return 'typework-w-cell'
        } else if (typwork === 'S') {
          return 'typework-s-cell'
        } else if (typwork === 'T') {
          return 'typework-t-cell'
        } else if (typwork === 'L') {
          return 'typework-l-cell'
        }
      }
    })
  }

  let indexChildColumns = []
  // indexChildColumns.push({
  //   key: 'codcalen',
  //   name: 'รหัสกลุ่ม',
  //   class: 'align-center',
  //   style: 'min-width: 100px;'
  // })
  indexChildColumns.push({
    key: 'codempid',
    name: '',
    labelCodapp: 'HRMS18E',
    labelIndex: '150',
    class: 'align-center',
    style: 'min-width: 200px;',
    inlineFlgEditDisabled: true,
    inlineType: 'lov',
    eventName: 'codempid',
    lovType: 'codempid',
    validateRules: 'required'
  })
  indexChildColumns.push({
    key: 'desc_codempid',
    name: '',
    labelCodapp: 'HRMS18E',
    labelIndex: '70',
    style: 'min-width: 200px;'
  })

  for (let day = 1; day <= dayInMonth; day++) {
    indexChildColumns.push({
      key: 'codshift' + _.padStart(day, 2, '0'),
      name: '',
      labelCodapp: 'CODSHIFT',
      labelIndex: _.padStart(day, 2, '0'),
      class: 'align-center',
      style: 'min-width: 60px;',
      inlineType: 'text',
      eventName: 'codshift' + _.padStart(day, 2, '0'),
      columnDisabledCondition (dataRow, key, index) {
        let columnDay = parseInt(key.replace('codshift', ''))
        let month = dataRow.month
        let year = dataRow.year
        let columnDate = moment(columnDay + '/' + month + '/' + year, 'DD/MM/YYYY')
        let currentDate = moment().startOf('day')
        return columnDate < currentDate
        // let currentDay = moment().get('date')
        // return columnDay < currentDay
      },
      columnClassCondition (dataRow, key, index) {
        let day = key.substring(8)
        let typwork = dataRow['typwork' + day]
        if (typwork === 'H') {
          return 'typework-h-cell'
        } else if (typwork === 'W') {
          return 'typework-w-cell'
        } else if (typwork === 'S') {
          return 'typework-s-cell'
        } else if (typwork === 'T') {
          return 'typework-t-cell'
        } else if (typwork === 'L') {
          return 'typework-l-cell'
        }
      }
    })
  }

  return {
    en: {
      indexParent: indexParentColumns,
      indexChild: indexChildColumns
    },
    th: {
      indexParent: indexParentColumns,
      indexChild: indexChildColumns
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/columns/hrms18e.js